export const TOOL_REASON_UI_MAX_LENGTH = 100;

export const DEFAULT_TOOL_REASON = 'Applying the requested change';

export function getToolInputRecord(value: unknown): Record<string, unknown> | undefined {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return undefined;
  }

  return value as Record<string, unknown>;
}

export function extractToolReason(input: unknown, maxLength?: number): string | undefined {
  const record = getToolInputRecord(input);
  if (!record || typeof record.reason !== 'string') {
    return undefined;
  }

  const normalized = record.reason.replace(/\s+/g, ' ').trim();
  if (!normalized) {
    return undefined;
  }

  if (!maxLength || normalized.length <= maxLength) {
    return normalized;
  }

  return `${normalized.slice(0, maxLength - 3).trimEnd()}...`;
}

export function isDefaultToolReason(reason: string): boolean {
  return reason.trim().toLowerCase() === DEFAULT_TOOL_REASON.toLowerCase();
}

export function extractDisplayToolReason(input: unknown, maxLength?: number): string | undefined {
  const reason = extractToolReason(input, maxLength);
  if (!reason || isDefaultToolReason(reason)) {
    return undefined;
  }

  return reason;
}

export function extractToolReasonFromArgsText(toolArgsAccumulated: string): string | undefined {
  const match = toolArgsAccumulated.match(/"reason"\s*:\s*"((?:\\.|[^"\\])*)"/);
  if (!match) {
    return undefined;
  }

  try {
    return JSON.parse(`"${match[1]}"`) as string;
  } catch {
    return undefined;
  }
}
